import React from 'react'
import styled from '@emotion/styled'

type Props = {
  children?: any
  clickable?: boolean
}

type TrProps = {
  clickable?: boolean
}

const StyledTr = styled.tr<TrProps>`
  border-left: 5px white solid;
  &:hover {
    cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
    background-color: #f6f9fd;
    border-left: 5px solid #1665d8;
  }
`

const TableRow = ({ children, clickable }: Props) => (
  <StyledTr clickable={clickable}>{children}</StyledTr>
)

export default TableRow
